import { lookupCTVKeysForKeyCode } from '../utils/ctv-input';
import { Observable } from '../utils/observables/observable';
/**
 * @public
 */
export class Input {
    keyCodeMap = {};
    preventDefault = new Set([-1]);
    keyUpObservable = new Observable();
    keyDownObservable = new Observable();
    constructor(window) {
        window.onkeydown = (event) => {
            this.handleKeyDown(event);
        };
        window.onkeyup = (event) => {
            this.handleKeyUp(event);
        };
    }
    onKeyUp(handler) {
        this.keyUpObservable.registerObserver(handler, this);
    }
    onKeyDown(handler) {
        this.keyDownObservable.registerObserver(handler, this);
    }
    removeKeyUpListener(handler) {
        this.keyUpObservable.unregisterObserver(handler);
    }
    removeKeyDownListener(handler) {
        this.keyDownObservable.unregisterObserver(handler);
    }
    removeAllKeyUpListeners() {
        this.keyUpObservable.unregisterObservers(this);
    }
    removeAllKeyDownListeners() {
        this.keyDownObservable.unregisterObservers(this);
    }
    removeAllListeners() {
        this.keyUpObservable.unregisterObservers(this);
        this.keyDownObservable.unregisterObservers(this);
    }
    handleKeyDown(event) {
        this.handleKeyEvent(this.keyDownObservable, event);
    }
    handleKeyUp(event) {
        this.handleKeyEvent(this.keyUpObservable, event);
    }
    handleKeyEvent(keyEventObservable, event) {
        if (this.preventDefault.has(event.keyCode)) {
            // TODO is this check truly necessary?
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (event.preventDefault) {
                event.preventDefault();
            }
        }
        const ctvKeys = lookupCTVKeysForKeyCode(this.keyCodeMap, event.keyCode);
        const [key, secondaryKey, ...otherKeys] = ctvKeys;
        const extendedEvent = {
            key,
            keyCode: event.keyCode,
        };
        if (ctvKeys.length > 1) {
            extendedEvent.secondaryKey = secondaryKey;
            extendedEvent.otherKeys = [secondaryKey, ...otherKeys];
        }
        keyEventObservable.notifyObservers(extendedEvent);
    }
}
//# sourceMappingURL=input.js.map